export const StoreTypes = ["STORE:Store", "SUPERMARKET:Super market", "RESELLER:Reseller", "DISTRIBUTOR:Distributor"]


export const TransactionTypes = ["Topup:topup", "Bills Payment:billspayment", "Gift:gift"]